// Spice level on a Customs plate card. The import sets plate.heat to
// 'none' | 'mild' | 'extra' (absent = regular). For a not-spicy meal it has already
// swapped hot vegetables and sauces for heat-free ones (they show as swap lines);
// plate.heat_sources lists the heat still on the plate, e.g. a protein's marinade,
// which stays as it is. plate.heat_lookalikes names hot batches elsewhere on the menu
// of a plain ingredient on this plate (the steak's Cremini Mushrooms vs the
// chili-flake Mushrooms roasted for the salmon), so the cook plates the plain one.

const HEAT_LABEL = {
  none: { label: 'NO HEAT', cls: 'bg-orange-50 border-orange-400 text-orange-900' },
  mild: { label: 'MILD', cls: 'bg-amber-50 border-amber-400 text-amber-900' },
  extra: { label: 'EXTRA HEAT', cls: 'bg-rose-50 border-rose-400 text-rose-900' },
}

export function heatBanner(plate) {
  const heat = String(plate?.heat || '').trim().toLowerCase()
  const style = HEAT_LABEL[heat]
  if (!style) return null
  const sources = Array.isArray(plate?.heat_sources) ? plate.heat_sources.filter(Boolean) : []
  let detail
  if (heat === 'extra') {
    detail = sources.length
      ? `Heat on this dish: ${sources.join(' · ')}`
      : 'No heat ingredient is listed for this dish — check the recipe.'
  } else {
    detail = sources.length
      ? `Heat still on the plate: ${sources.join(' · ')}`
      : 'No heat left on this plate.'
  }
  return { heat, ...style, detail, lookalikes: heat === 'extra' ? [] : lookalikeLines(plate) }
}

export function lookalikeLines(plate) {
  const rows = Array.isArray(plate?.heat_lookalikes) ? plate.heat_lookalikes : []
  return rows.flatMap((row) => {
    const avoid = (Array.isArray(row?.avoid) ? row.avoid : []).filter((a) => a?.name)
    if (!row?.component || !avoid.length) return []
    const batches = avoid.map((a) => (a.dish ? `${a.name} (${a.dish})` : a.name))
    const heat = [...new Set(avoid.flatMap((a) => (Array.isArray(a.heat) ? a.heat : [])))]
    const has = heat.length ? `, which ${avoid.length > 1 ? 'have' : 'has'} ${heat.join(', ')}` : ', which has heat'
    return [`${row.component}: use the plain batch, not ${batches.join(' or ')}${has}.`]
  })
}
